import { GenericLazyString } from '@eventbrite/i18n';
import React from 'react';

interface IIconButton {
    'data-testid'?: string;
    iconType: JSX.Element;
    onClick: () => void;
    style?: 'outline' | 'none';
    title?: string | GenericLazyString;
    iconSize?: 'xsmall' | 'small';
}

const IconButton = ({
    'data-testid': dataTestId,
    iconType,
    onClick,
    style,
    title,
    iconSize = 'small',
}: IIconButton): React.ReactElement => {
    let spanClass = 'eds-btn--button eds-btn--none eds-btn--icon-only';

    if (style === 'outline') {
        spanClass = 'eds-icon-button eds-icon-button--outline';
    } else if (style === 'none') {
        spanClass = '';
    }
    return (
        <span data-testid="icon-button-component" className={spanClass}>
            <button
                type="button"
                onClick={onClick}
                className="eds-btn--button eds-btn--none eds-btn--icon-only"
                data-testid={dataTestId}
            >
                <i
                    className={`eds-vector-image eds-icon--${iconSize} eds-vector-image--block`}
                    title={title?.toString()}
                    data-testid="element-title"
                >
                    {iconType}
                    <span
                        className="eds-is-hidden-accessible"
                        data-testid="element-accesible-title"
                    >
                        {title}
                    </span>
                </i>
            </button>
        </span>
    );
};

export default IconButton;
